import { useState } from 'react';
import Cropper from 'react-easy-crop';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton';

import getCroppedImgData from '../functions/cropImage';

import './styles/ImageCropper.css';

const ImageCropper = ({ source, 
  width, 
  height, 
  cropShape, 
  aspect = null, 
  defaultFullImageCrop = false,
  setCroppedFile, 
  exitCrop,
  setCroppedUrl = null, 
  continueCrop = () => {}, 
  continueLabel = "Choose",
  exitLabel = "Exit",
  isLoading }) => {
  const [zoom, setZoom] = useState(1);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [mediaSize, setMediaSize] = useState(null);

  // Use the aspect prop if provided; otherwise, fallback to dynamic width/height aspect ratio
  const hasProvidedAspect = Number.isFinite(aspect) && aspect > 0;
  const hasDimensions = Number.isFinite(width) && Number.isFinite(height) && height > 0;
  const aspectRatio = hasProvidedAspect ? aspect : (hasDimensions ? (width / height) : 1);

  const onCropChange = (newCrop) => {
    setCrop(newCrop);
  };

  const onZoomChange = (newZoom) => {
    setZoom(newZoom);
  };

  const onCropComplete = (croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  };

  const getFullImageCropArea = () => {
    if (!mediaSize) {
      return null;
    }

    const naturalWidth = Math.round(mediaSize.naturalWidth || mediaSize.width || 0);
    const naturalHeight = Math.round(mediaSize.naturalHeight || mediaSize.height || 0);

    if (!naturalWidth || !naturalHeight) {
      return null;
    }

    return {
      x: 0,
      y: 0,
      width: naturalWidth,
      height: naturalHeight
    };
  };

  const onCrop = async () => {
    try {
      let finalCroppedAreaPixels = croppedAreaPixels;
      if (!finalCroppedAreaPixels && defaultFullImageCrop) {
        finalCroppedAreaPixels = getFullImageCropArea();
      }

      if (!finalCroppedAreaPixels) {
        return;
      }

      const blobFile = await getCroppedImgData(source, finalCroppedAreaPixels);
      const file = new File([blobFile], 'croppedImage.png', { type: 'image/png' });
  
      if (setCroppedFile && typeof setCroppedFile === "function") {
        setCroppedFile(file);
      } else {
        console.error("setCroppedFile is not a function");
      }
  
      if (typeof setCroppedUrl === "function") {
        const fileUrl = URL.createObjectURL(file);
        setCroppedUrl(fileUrl);
      }
    } catch (e) {
      console.error("Error during cropping in ImageCropper:", e);
    }
  };
  
  const handleWheel = (e) => {
    const direction = e.deltaY > 0 ? -0.1 : 0.1;
    const newZoom = zoom + direction;
    setZoom(newZoom > 1 ? newZoom : 1);
  };
  
  const cropAreaClass = cropShape === 'circle' ? 'crop-circle' : 'crop-rect';
  const cropperShape = cropShape === 'circle' ? 'round' : 'rect';

  return (
    <>
      <div onWheel={handleWheel} className={`w-100 container-wheel-cropper ${cropAreaClass}`} >
        <Cropper
          image={source}
          crop={crop}
          zoom={zoom}
          aspect={aspectRatio}
          cropShape={cropperShape}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          showGrid={true}
          onCropComplete={onCropComplete}
          onMediaLoaded={setMediaSize}
        />
      </div>
      <div className="artwork-options__download-template-templates-crop-options">
        <div className="artwork-options__footer-background">
          <p onClick={exitCrop}>{exitLabel}</p>
          <ContinueButton 
            loading={isLoading}
            className="choose-action"
            continueClass={false}
            onClick={async () => {
              await onCrop();
              continueCrop();
            }}
          >
            {continueLabel}
          </ContinueButton>
        </div>
      </div>
    </>
  );
};

export default ImageCropper;
